import { useEffect, useState } from "react";
import axios from "axios";
import { MAIN_URL } from "../redux/UserAPI";
import { ICountry } from "../interfaces";

export function useCountries() {
  const [countries, setCountries] = useState<ICountry[]>([]);
  const [countriesLoading, setCountriesLoading] = useState(true);
  const [countriesError, setCountriesError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    axios
      .get(`${MAIN_URL}/form/countries`)
      .then((response) => {
        if (!isMounted) return;
        setCountries(response.data.countries || []);
      })
      .catch(() => {
        if (!isMounted) return;
        setCountriesError(true);
      })
      .finally(() => {
        if (!isMounted) return;
        setCountriesLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return { countries, countriesLoading, countriesError };
}
